import React, { Component } from 'react'
// import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import config from 'config'
// import * as searchActions from 'redux/modules/search'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  // SocialButtons,
  GetStartedInput,
  FamilyGrid,
  BenchmarkGrid,
  TargetDateGrid,
  AboutBanner,
  ScreenedCompanies,
  AutocompleteSearch,
  SrOnly,
  InlineSignup,
  InlineDonate,
  AykCtaPanel,
} from '../../components'
import format from '../../helpers/format'
// import Loader from 'react-loader'

const Styles = require('./Home.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }
  //
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }
  //
  render() {
    // const link = config.domain
    // const message = config.shareMessage
    // const iyvLogo = require( '../../../static/images/iyv-logo-project-of-2021.jpg' )

    return (
      <div styleName="main">

        <div styleName='banner-wrapper'>
          <div styleName='banner-wrapper-gray'>
            <div styleName='banner-container'>
              <div styleName='banner-container-inner'>
                <div styleName='image-banner-green'>
                  <div styleName='image-banner-headline'>
                    We have the power to cut our financial ties to gun violence
                  </div>
                  <div styleName='search-box-border'>
                    <div styleName='banner-tagline-2'>
                      Check your mutual funds for investments in gun companies
                    </div>
                    <AutocompleteSearch />
                  </div>
                  <div styleName='banner-btn-box-border'>
                    <div styleName='banner-tagline'>
                      Find sustainable, gun free mutual funds and ETFs
                    </div>
                    <div styleName='banner-btn-wrap'>
                      <Link
                        to={config.routes.clean}
                        bigbutton
                        title='Top-scoring funds'
                      >
                        <div>
                          Top-scoring funds<LinkIcon />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AykCtaPanel />

        <ContainerDivs>
            { /*
            <div styleName='title'>
              <img
                src={iyvLogo}
                styleName='iyv-logo'
                alt='Invest Your Values - a project of As You Sow'
              />
            </div> */ }

            <h2 styleName='lede-section__headline'>
              Violence isn’t a sustainable investment
            </h2>

            <p styleName='lede-section__copy'>
              People are investing their life savings into
              firearm manufacturers and
              retailers raking in billions in handgun, assault rifle, and
              ammunition sales. <b>Most don’t even know it.</b>
            </p>

            <p styleName='lede-section__copy'>
              We don’t need to
              profit from violence when we're investing in our retirement
              accounts.
              From non-profit As You Sow, Gun Free Funds is made for people
              looking to align their investments with their values by
              moving money out of companies that make and sell guns.
            </p>

            <p styleName='lede-section__copy'>
              Our tool shows you any gun investments that may be
              hidden inside the mutual funds you own.
              We also have an action toolkit to answer questions like how
              to ask your employer to provide gun free 401(k) investment
              options.
            </p>

            <p styleName='lede-section__copy'>
              <b>It’s your choice -
              take control and make sure your investments are not profiting
              from “blood money.”</b>
            </p>

            <div styleName='lede-section__links'>
              <Link to={config.routes.list} title='Fund database' roundbutton>
                Fund database<LinkIcon />
              </Link>

              <Link to={config.routes.toolkit} title='Action toolkit' roundbutton>
                Action toolkit<LinkIcon />
              </Link>
            </div>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <InlineSignup />
            <br/>
            <br/>

        </ContainerDivs>

        { /* <SocialButtons message={message} link={link} /> */ }

        <Works/>
        <ContainerDivs>
          <div styleName='small-title'>
            Gun manufacturers and retailers
          </div>
          <p styleName='h3 narrow'>
            If you own mutual funds or exchange-traded funds (ETFs),
            there’s a good chance that you own shares of gun
            manufacturers and gun retailers profiting from the bloodshed
            of mass shootings and gun violence.
          </p>
          <ScreenedCompanies />

          <br/>
          <br/>
          <br/>
          <InlineDonate />
          <br/>
          <br/>
          <br/>

        </ContainerDivs>
        
        <GetStartedInput />
        
        <ContainerDivs>
          <AboutBanner />
        </ContainerDivs>

      </div>
    )
  }
}

